import React from 'react';
import { Handle, Position } from '@xyflow/react';

const NODE_SIZE = { width: 220, height: 120 };

function VirtualMachineNode({ data, selected }) {
  return (
    <div
      className={`relative rounded-lg border-2 p-3 transition-colors ${
        selected
          ? 'border-purple-500 bg-purple-50/70 dark:bg-purple-900/30'
          : 'border-purple-300 bg-purple-50/40 dark:bg-purple-900/20'
      }`}
      style={NODE_SIZE}
    >
      <Handle type="target" position={Position.Top} className="!bg-purple-500" />
      <div className="mb-1 flex items-center gap-2">
        <svg
          className="h-4 w-4 text-purple-600 dark:text-purple-400 shrink-0"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          aria-hidden="true"
        >
          <rect x="2" y="3" width="20" height="14" rx="2" />
          <path d="M8 21h8M12 17v4" />
        </svg>
        <span className="text-sm font-semibold text-purple-900 dark:text-purple-100 truncate">
          {data.name}
        </span>
      </div>
      {data.sku && (
        <span className="inline-block bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200 text-xs font-mono px-2 py-0.5 rounded">
          {data.sku}
        </span>
      )}
      <div className="mt-1 text-xs text-gray-500 dark:text-gray-400">Virtual Machine</div>
      <Handle type="source" position={Position.Bottom} className="!bg-purple-500" />
    </div>
  );
}

export default VirtualMachineNode;
